module.exports = __webpack_public_path__ + "static/media/ProfileSetup.a39cfae4.png";